import { useEffect } from 'react';
import {
  SET_USER_INFO,
  GET_USER_SESSION_DETAILS,
  GET_TEG_USER_DATA,
} from 'Constants/actionConstants';
import User from 'Models/User';
import {
  storeCompanyId,
  storeCompanyType,
  storeIsSettingsVisible,
  storeToken,
  storeUser,
} from 'Utils/storage';
import { isValueThere, isRILCompany } from 'Utils/index';
import { CONTRACTING_MODULE_ID, SEEKER_VALUE } from 'Constants/commonConstants';

const useRedirecting = (props) => {
  const { dispatch, history } = props;
  const queryParams = new URLSearchParams(window.location.search);

  const handleLoginRedirection = () => {
    const token = queryParams.get('token');
    const toPathUrl = queryParams.get('toPathUrl');
    let toPathNavUrl = toPathUrl;

    const onSuccess = (data = {}) => {
      if (isValueThere(data.token) === false) {
        return;
      }

      dispatch({
        type: GET_TEG_USER_DATA,
        module: CONTRACTING_MODULE_ID,
        token: data.token,
      });

      const user = new User(data);
      storeToken(data.token);
      storeUser(user);
      storeCompanyType(data.company_type);
      storeCompanyId(data.id);

      dispatch({ type: SET_USER_INFO, payload: data });

      if (data.is_visible) {
        storeIsSettingsVisible('true');
      } else {
        storeIsSettingsVisible('');
      }

      if (user.contracting === true || user.reports === true) {
        localStorage.setItem('teg-component', true);
        if (isValueThere(toPathUrl) === false) {
          if (data.company_type === SEEKER_VALUE) {
            toPathNavUrl = isRILCompany(data.id) ? '/nsr/seeker-home' : '/seeker';
          } else {
            toPathNavUrl = '/transporters';
          }
        }
        history.replace(toPathNavUrl);
      }
    };

    const onError = () => {
      history.replace('/');
    };

    dispatch({
      type: GET_USER_SESSION_DETAILS,
      token,
      onSuccess,
      onError,
    });

    dispatch({
      type: GET_TEG_USER_DATA,
      module: CONTRACTING_MODULE_ID,
      token,
    });
  };

  const handleRedirection = () => {
    const type = +queryParams.get('type');
    switch (type) {
      case 1: {
        handleLoginRedirection();
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    handleRedirection();
  }, []);

  return {};
};

export default useRedirecting;
